import axios, { AxiosInstance } from 'axios';
import Configuration from '../utils/Configuration';
import store from '@/store/Store';
import { setUpRedirectToLogin } from '@/api/utils/redirectToLogin';

function initAxios() {
  const $http = axios.create();
  const baseUrl = getBaseUrl();
  setBaseUrl($http, baseUrl);
  setUpRedirectToLogin($http);
  setUpUpdateToken($http);
  return $http;
}

function setBaseUrl($http: AxiosInstance, baseUrl: string) {
  $http.defaults.baseURL = baseUrl;
}

function getBaseUrl() {
  return Configuration.value('VUE_APP_ADMIN_API_BASE_URL');
}

const createUpdateAuthInterceptor = () => async (error: any) => {
  if (error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
    await store.dispatch('userModule/logout');
  }
  throw error;
};

function setUpUpdateToken($http: AxiosInstance) {
  $http.interceptors.request.use(async (config: any) => {
    const token = await store.dispatch('userModule/checkAuth', null, { root: true });
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  }, createUpdateAuthInterceptor());
}

const $http: AxiosInstance = initAxios();

export { $http, getBaseUrl, setBaseUrl };
